import axiosInstance from './axiosInstance'

export interface AppNotification {
  id:         string
  type:       string
  title:      string
  body:       string | null
  entityType: string | null
  entityId:   string | null
  isRead:     boolean
  createdAt:  string
}

export const notificationsApi = {

  getAll: async (unreadOnly = false, limit = 50): Promise<AppNotification[]> => {
    const res = await axiosInstance.get<{ data: AppNotification[] }>('/notifications', {
      params: { unreadOnly, limit },
    })
    return res.data.data
  },

  getUnreadCount: async (): Promise<number> => {
    const res = await axiosInstance.get<{ data: { count: number } }>('/notifications/unread-count')
    return res.data.data.count
  },

  markRead: async (id: string): Promise<void> => {
    await axiosInstance.patch(`/notifications/${id}/read`)
  },

  markAllRead: async (): Promise<void> => {
    await axiosInstance.post('/notifications/read-all')
  },

  delete: async (id: string): Promise<void> => {
    await axiosInstance.delete(`/notifications/${id}`)
  },

  clearAll: async (): Promise<void> => {
    await axiosInstance.delete('/notifications/clear')
  },
}
